import * as types from './mutation-types'
import Vue from 'vue'

const state = {
  bookingInfo: {
    createDate: '',
    currencyUnit: 'uk',
    date: '30-7-2018',
    photographerProfileImage: 'Photographer url',
    price: 0,
    serviceId: 'hash',
    status: 'request',
    photographerId: 'hash',
    photographerName: 'PhotographerName',
    userName: 'UserName',
    uid: 'hash',
    userProfileImage: 'https://fire',
    reservations: {
      '2018-12-01': {
        0: {
          endTime: 60,
          reservationId: 'Hash.....'
        }
      }
    }
  }
}

const getters = {
  requestBookingInfo: state => state.bookingInfo
}

const actions = {
  async [types.SET_REQUEST_USER_BOOKING]({ commit }, payload) {
    return commit(types.SET_REQUEST_USER_BOOKING, payload)
  },
  async [types.CLEAR_REQUEST_USER_BOOKING]({ commit }, payload) {
    return commit(types.CLEAR_REQUEST_USER_BOOKING, payload)
  },
  [types.SET_REQUEST_USER_DATE]({ commit }, payload) {
    commit(types.SET_REQUEST_USER_DATE, payload)
  }
  // async [types.SAVE_REQUEST_USER_BOOKING]({ commit, state }, payload) {
  //   // commit(types.SAVE_REQUEST_USER_BOOKING, payload)
  //   // return new RequestPageApi().add(state.bookingInfo)
  // }
}

const mutations = {
  [types.SET_REQUEST_USER_BOOKING](state, result) {
    for (let key in result) {
      Vue.set(state.bookingInfo, key, result[key])
    }
  },
  [types.SET_REQUEST_USER_DATE](state, result) {
    state.bookingInfo.date = result.date
  },
  [types.CLEAR_REQUEST_USER_BOOKING](state) {
    let date = ''

    if (state.bookingInfo.date !== '') {
      date = state.bookingInfo.date
    }

    state.bookingInfo = {
      date: date,
      price: '',
      description: '',
      photographerId: '',
      serviceId: 0
    }
  }
  // [types.SAVE_REQUEST_USER_BOOKING](state, result) {
  //   // If the properties match, declare a value for the matching property.
  //   // for (let key in result) {
  //   //     state.bookingInfo[key] = result[key]
  //   // }
  // }
}

export default {
  state,
  getters,
  actions,
  mutations
}
